import * as React from 'react';
import {
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  TextField,
  DateField,
  ReferenceField,
  ReferenceInput,
} from 'react-admin';

const useTxtData = {
  table: {
    id: 'id',
    jinying_id: '经营企业',
    name: '设备名称',
    type: '设备类型',
    status: '状态',
    xuhao: '设备型号',
    AtTime: '登记时间',
  }
};

export const S_xumu_shebeiList = (props) => (
  <List {...props} filters={<Filters />}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <ReferenceField label={useTxtData.table.jinying_id} source="jinying_id" reference="Admin/CMSS_jinyingzhuti">
        <TextField source="ComName" />
      </ReferenceField>
      <TextField label={useTxtData.table.name} source="name" />
      <TextField label={useTxtData.table.type} source="type" />
      <TextField label={useTxtData.table.status} source="status" />
      <TextField label={useTxtData.table.xuhao} source="xuhao" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
    </Datagrid>
  </List>
);

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="经营企业" source="jinying_id" reference="Admin/CMSS_jinyingzhuti" alwaysOn>
      <SelectInput optionText="ComName" />
    </ReferenceInput>
    <SelectInput label={useTxtData.table.type} source="type" choices={[
      { id: '风机', name: '风机' },
      { id: '水帘', name: '水帘' },
      { id: '喷淋', name: '喷淋' },
      { id: '照明', name: '照明' },
      { id: '消毒', name: '消毒' },
    ]} />
    <SelectInput label={useTxtData.table.status} source="status" choices={[
      { id: '在线', name: '在线' },
      { id: '离线', name: '离线' },
      { id: '故障', name: '故障' },
    ]} />
  </Filter>
);

export const S_xumu_shebeiEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput label="经营企业" source="jinying_id" reference="Admin/CMSS_jinyingzhuti">
        <SelectInput optionText="ComName" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.name} source="name" />
      <SelectInput label={useTxtData.table.type} source="type" choices={[
        { id: '风机', name: '风机' },
        { id: '水帘', name: '水帘' },
        { id: '喷淋', name: '喷淋' },
        { id: '照明', name: '照明' },
        { id: '消毒', name: '消毒' },
      ]} />
      <SelectInput label={useTxtData.table.status} source="status" choices={[
        { id: '在线', name: '在线' },
        { id: '离线', name: '离线' },
        { id: '故障', name: '故障' },
      ]} />
      <TextInput label={useTxtData.table.xuhao} source="xuhao" />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Edit>
);

export const S_xumu_shebeiCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput label="经营企业" source="jinying_id" reference="Admin/CMSS_jinyingzhuti">
        <SelectInput optionText="ComName" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.name} source="name" />
      <SelectInput label={useTxtData.table.type} source="type" choices={[
        { id: '风机', name: '风机' },
        { id: '水帘', name: '水帘' },
        { id: '喷淋', name: '喷淋' },
        { id: '照明', name: '照明' },
        { id: '消毒', name: '消毒' },
      ]} />
      <SelectInput label={useTxtData.table.status} source="status" choices={[
        { id: '在线', name: '在线' },
        { id: '离线', name: '离线' },
        { id: '故障', name: '故障' },
      ]} />
      <TextInput label={useTxtData.table.xuhao} source="xuhao" />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Create>
);